import { OktaAuth } from "@okta/okta-auth-js";
import { customerOktaConfig } from "../../config";
import getOktaConfig from "./getOktaConfig";

// One instance per mode: customer tokens live in localStorage, merchant in sessionStorage.
const _instances = {};

export const getOktaAuth = () => {
  const config = getOktaConfig();
  const key = config === customerOktaConfig ? "customer" : "merchant";

  if (!_instances[key]) {
    _instances[key] = new OktaAuth(config);
  }

  return _instances[key];
};

export const getAccessToken = () => getOktaAuth().getAccessToken();
export const getIdToken = () => getOktaAuth().getIdToken();

export const clearTokenManager = () => getOktaAuth().tokenManager.clear();
